/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';

import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Stack,
  Typography,
} from '@mui/material';

import ClauseCard from './ClauseCard';
import { handleSeeMoreAndLess } from '../../hooks/Helper';

interface IProps {
  sections?: any;
  openBoot: VoidFunction;
  setBotFrom: any;
}

const ClauseLibrary = (props: IProps) => {
  const { sections, openBoot, setBotFrom } = props;
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const [showFullText, setShowFullText] = useState<any>({
    id: '',
    show: false,
  });

  const handleShowMoreToggle = (id: string) => {
    if (showFullText.id === id) {
      setShowFullText({
        id: 0,
        show: false,
      });
    } else {
      setShowFullText({
        id: id,
        show: true,
      });
    }
  };

  return (
    <>
      {sections?.map((data: any, index: number) => (
        <Accordion
          key={`${data?.section_name}-clause-${index}`}
          onChange={handleChange(data?.id)}
          expanded={expanded === data?.id}
          disabled={data?.clause_library === null}
          className="according-class"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className="clause-heading"
          >
            <Stack
              direction="row"
              sx={{
                justifyContent: 'space-between',
                width: '100%',
                alignItems: 'center',
              }}
            >
              <Typography>{data.field_name}</Typography>
              <Typography>
                {data.clause_library?.split('//')?.length || 0}
              </Typography>
            </Stack>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: 0, mt: 0 }}>
            <Stack>
              <Stack className="ulta-ai-button-container">
                <Button
                  className="ulta-ai-button"
                  sx={{
                    alignSelf: 'end',
                    padding: '1.5px 10px',
                    backgroundColor: 'white',
                    margin: '2px 3px',
                    borderRadius: '5px',
                    width: 'fit-content',
                    '&:hover': {
                      backgroundColor: 'white',
                    },
                  }}
                  onClick={() => {
                    openBoot();
                    setBotFrom({
                      type: 'clause_library',
                      content: {
                        clause: data.field_name,
                        data: data.clause_library?.split('//'),
                      },
                    });
                  }}
                  startIcon={<ChatBubbleOutlineIcon />}
                  size="small"
                >
                  Ask Ultra AI
                </Button>
              </Stack>
            </Stack>
            {data.clause_library
              ?.split('//')
              ?.map((para: any, index: number) => {
                const id = `${data.id}-${index}`;
                return (
                  <ClauseCard
                    key={`${data.section_name}-para-${index}`}
                    index={index}
                  >
                    <Stack style={{ width: '100%' }}>
                      <Typography>
                        {showFullText?.id === id && showFullText?.show
                          ? para
                          : handleSeeMoreAndLess(para)}
                      </Typography>
                      <Button
                        variant="text"
                        sx={{
                          minWidth: 'auto',
                          alignSelf: 'end',
                          marginTop: 0,
                          padding: 0,
                          color: '#0f6cbd',
                        }}
                        onClick={() => handleShowMoreToggle(id)}
                      >
                        {showFullText?.id === id && showFullText?.show
                          ? 'See less'
                          : 'See more'}
                      </Button>
                      {showFullText?.id === id && showFullText?.show && (
                        <Button
                          variant="contained"
                          sx={{ alignSelf: 'end' }}
                          // onClick={() => replaceText(para)}
                        >
                          Replace Text
                        </Button>
                      )}
                    </Stack>
                  </ClauseCard>
                );
              })}
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};

export default ClauseLibrary;
